module.exports = __webpack_public_path__ + "img/number-3.87425639.svg";